import { loadAppSetting, resetAppSetting, saveAppSetting } from '$lib/app-settings.js';

export const CAMERA_RECORDING_SETTING_KEY = 'camera.recording';

export const FALLBACK_CAMERA_RECORDING_CONFIG = {
  profile: 'standard',
  capture: {
    facingMode: 'environment',
    resolution: '1920x1080',
    frameRate: 30,
    audioEnabled: false
  },
  recording: {
    transportMode: 'websocket-ffmpeg',
    segmentDurationMs: 3000,
    preferredMimeType: 'video/webm;codecs=vp8',
    videoBitsPerSecond: 2500000,
    audioBitsPerSecond: 128000
  },
  output: {
    format: 'mp4',
    fileNamePattern: 'camera-{date}-{sessionId}',
    shareToCloud: true
  },
  ui: {
    showGridlines: true
  },
  ffmpeg: {
    preset: 'veryfast',
    crf: 23,
    movFlagsFastStart: true
  },
  availableProfiles: [],
  availableResolutionPresets: [],
  availableFrameRates: [24, 25, 30, 50, 60],
  availableSegmentDurations: [2000, 3000, 5000, 10000, 15000],
  availableMimeTypes: [],
  supportedOutputFormats: [],
  supportedFfmpegPresets: []
};

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function deepMerge(base, override) {
  if (!isPlainObject(base) || !isPlainObject(override)) return override ?? base;

  const result = { ...base };
  for (const [key, value] of Object.entries(override)) {
    result[key] = isPlainObject(value) && isPlainObject(base[key])
      ? deepMerge(base[key], value)
      : value;
  }

  return result;
}

export function normalizeCameraRecordingConfig(value = {}) {
  return deepMerge(FALLBACK_CAMERA_RECORDING_CONFIG, value || {});
}

export async function loadCameraRecordingSetting() {
  const response = await loadAppSetting(CAMERA_RECORDING_SETTING_KEY);

  return {
    ...response,
    defaults: normalizeCameraRecordingConfig(response?.defaults),
    system: response?.system || null,
    user: response?.user || null,
    effective: normalizeCameraRecordingConfig(response?.effective)
  };
}

export async function saveCameraRecordingSetting(value, scope = 'user') {
  const normalized = normalizeCameraRecordingConfig(value);
  await saveAppSetting(CAMERA_RECORDING_SETTING_KEY, normalized, scope);
  return normalized;
}

export async function resetCameraRecordingSetting() {
  await resetAppSetting(CAMERA_RECORDING_SETTING_KEY);
  return loadCameraRecordingSetting();
}
